import type { AnalyticFields } from "@octopusdeploy/portal-analytics";
import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { PageInstanceSummary } from "../page/PageInstanceSummary";
import { usePageInstanceSummary } from "../page/PageInstanceSummaryProvider";

export type PageEventDispatcher = (name: string, eventFields: AnalyticFields) => void;

export interface PageFields {
    "Page Area": string;
    "Page Id": string;
}

export function getPageFields(page: PageInstanceSummary): PageFields {
    return {
        "Page Area": page?.Area,
        "Page Id": page?.Id,
    };
}

export function usePageEventDispatcher(): PageEventDispatcher {
    const session = useAnalyticSession();
    const page = usePageInstanceSummary();

    return (name: string, eventFields: AnalyticFields) => {
        if (!page) {
            return;
        }

        const fields: PageFields = {
            ...getPageFields(page),
            ...eventFields,
        };

        session.track(name, fields);
    };
}
